import { render, staticRenderFns } from "./RouteAdd.vue?vue&type=template&id=3a5bda9a&scoped=true&"
import script from "./RouteAdd.vue?vue&type=script&lang=js&"
export * from "./RouteAdd.vue?vue&type=script&lang=js&"
import style0 from "./RouteAdd.vue?vue&type=style&index=0&id=3a5bda9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5bda9a",
  null
  
)

export default component.exports